// extracted by mini-css-extract-plugin
module.exports = {"schedule":"QuickBookingRestShortC_schedule__Vm2bk","slot":"QuickBookingRestShortC_slot__7yyD7","dots":"QuickBookingRestShortC_dots__P7Dw_"};